import React, { useState } from "react"
import GreenButton from "../../../shared/ui/Button/GreenButton.styled"
import posthog from "posthog-js"
import styled from "styled-components";
import { ModalBase } from "../../../shared/components/ModalBase";
import wineModal from "../assets/wine-modal.svg"
import whiskeyModal from "../assets/whiskey-modal.svg"


export const WineWhiskeyModal = ({btnLocation}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalOpen = () => {
        posthog.capture('select_get_started', {location: {btnLocation}});
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <GreenButton onClick={handleModalOpen} className={`sizedButton`} location={btnLocation}>Get Started</GreenButton>
            {isModalOpen && <GetStarted closeModal={handleCloseModal} />}
        </>
    )
}

export const GetStarted = ({ closeModal, isOpen }) => {
    const wineNext = () => {
        posthog.capture("select_invest_in", {
            type: "wine",
            location: "modal",
        });
        window.location.assign('/signup');
    }

    const whiskeyNext = () => {
        posthog.capture("select_invest_in", {
            type: "whiskey",
            location: "modal",
        });
        window.localStorage.setItem('whiskey_signup', 'true');
        window.location.assign('/signup');
    }

    return (
        <>
        {/* TODO: pass in isOpen once ModalBase is fixed... */}
            <ModalBase isOpen onClose={closeModal} borderRadius={20} additionalStyles={modalBaseStyles}>
                <ModalContainer>
                    <ModalTitle>
                        Where do you want to start?
                    </ModalTitle>
                    <ModalContent>
                        <p>You can open an account in just a few minutes. </p>
                        <BoxContainer>
                            <Wine>
                                <h3>Wine</h3>
                                <img src={wineModal} width={"61"} height={"91"} alt={'Wine Bottle'} />
                                <GreenButton onClick={wineNext} className={'modalCta'}>Next</GreenButton>
                            </Wine>
                            <Whiskey>
                                <h3>Whiskey</h3>
                                <img src={whiskeyModal} width={"83"} height={"86"} alt={'Whiskey Bottle'} />
                                <GreenButton onClick={whiskeyNext} className={'modalCta'}>Next</GreenButton>
                            </Whiskey>
                        </BoxContainer>
                    </ModalContent>
                </ModalContainer>
            </ModalBase>
        </>
    );
};

export const BoxContainer = styled.div`
    color: #FAE8D1;
    display: flex;
    gap: 5px;
    justify-content: space-between;
    margin-top: 40px;
    @media only screen and (min-width: 998px) {
        gap: 20px;
    }
    h3 {
        font-family: RoslindaleDisplayCondensed;
        font-size: 32px;
        font-weight: 500;
        margin: 0 0 20px;
    }
    div {
        border-radius: 4px;
        max-width: 280px;
        padding: 30px;
        text-align: center;
        width: 50%;
    }
    .modalCta {
        height: 50px;
        margin: 20px auto 0;
        max-width: 126px;
    }
`;

export const Wine = styled.div`
    background-color: #242E35;
`;

export const Whiskey = styled.div`
    background-color: #3C400C;
    img {
        margin-top: 5px;
    }
`;

export const ModalContainer = styled.div`
    width: 650px;
    margin: 0 auto;
    border-radius: 8px;
    background: #fff;
    @media screen and (max-width: 1023px) {
        width: 100%;
    }
`;

export const ModalTitle = styled.h2`
    background: white;
    border-radius: 8px 8px 0px 0px; 
    font-family: RoslindaleDisplayCondensed;
    font-size: 24px;
    font-weight: 500;
    margin: 0;
    padding: 80px 20px 0 20px;
    text-align: center;
    @media only screen and (min-width: 998px) {
        font-size: 36px;
    }
    & p {
        margin: 0px;
        @media only screen and (max-width: 400px) {
            max-width: 200px;
        }
    }
`;
export const ModalContent = styled.div`
    padding: 0 15px 40px;
    @media only screen and (min-width: 998px) {
        padding: 0 35px 40px;
    }
    p {
        font-size: 14px;
        margin: 10px auto;
        max-width: 280px;
        text-align: center;
        @media only screen and (min-width: 998px) {
            font-size: 16px;
            max-width: 100%;
        }
    }
`;
export const ModalFooter = styled.div``;

export const modalBaseStyles = `
    background: transparent;
    border-radius: 0px;
    box-shadow: none;

    .closeIcon {
        top : 16px;
    }
    
    @media screen and (max-width: 1023px) { 
        max-width: 600px; 
        width: 100%;
        padding: 0 17px;
        background: transparent;
        box-shadow: none;

        .closeIcon {
            right: 40px;
        }
    }
`;
